import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { TemplateCheckResponse } from '@/types/apps/template-check.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface TemplateCheckServiceInterface {}

type TemplateCheckGraphQLListResponse = GqlListResponse<TemplateCheckResponse>;

export class TemplateCheckGraphQLService
    extends BaseService
    implements TemplateCheckServiceInterface
{
    public getEntityName(): string {
        return 'templateCheck';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,

            // functionConfigs: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
        };
    }

    public async index(
        query: string
    ): Promise<TemplateCheckGraphQLListResponse> {
        return this.fetchGqlList<TemplateCheckGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('templateCheck', {
            userId: this.getQueryById(),
        });
    }
}
